export const setErrorMessage = (message, event) => {
  event.stopPropagation();
  event.target.setCustomValidity(message);
};

export const clearErrorMessage = (event) => {
  event.stopPropagation();
  event.target.setCustomValidity('');
};
